import "./style.css";
import React from "react";

export default function Formulario({ data }) {
    if (!data) return null;

    // Desestruturar os dados principais para facilitar o acesso
    const { studentIdentity, filiation, guardian, emergencyContacts, additionalInformation, educationGuardian } = data;

    return (
        <div className="bg-white p-2 flex flex-col gap-1 w-full">
            {/* Cabeçalho */}
            <div className="w-full flex justify-center mb-6">
                <div className="flex flex-col items-center gap-3">
                    <img src={require('../../assets/icons/nilia.webp')} className='logo' alt="Instituto Nilia" />
                    <div className="text-center">
                        <p className="form-title">FICHA DE INSCRIÇÃO E MATRÍCULA</p>
                        <div className="form-subtitle flex items-center gap-1 justify-center mt-1">
                            <span>Ano Lectivo de</span>
                            <span className="font-bold">2025</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Indicador de Classe */}
            <div className="w-full flex justify-end">
                <div className="border border-gray-300 px-2">
                    <span className="form-text font-bold">{data.level}</span>
                    <span className="form-text"> Classe</span>
                </div>
            </div>

            {/* Elementos de Identificação */}
            <div className="w-full">
                <h2 className="form-section-title">ELEMENTOS DE IDENTIFICAÇÃO</h2>

                <div className="flex items-center gap-2 mb-1">
                    <span className="form-text">Nome completo:</span>
                    <div className="flex-1">
                        <input type="text" className="w-full border border-black px-2 py-0 form-text" 
                            defaultValue={studentIdentity?.name} />
                    </div>
                    <span className="form-text ml-4">Sexo:</span>
                    <div className="flex gap-4">
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{studentIdentity?.gender === 'M' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">M</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{studentIdentity?.gender === 'F' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">F</span>
                        </div>
                    </div>
                </div>

                <div className="flex items-center gap-2 mb-1">
                    <span className="form-text">Nascido a:</span>
                    <input type="text" className="w-24 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.dob} />
                    <span className="form-text">em:</span>
                    <input type="text" className="w-40 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.birthPlace} />
                    <span className="form-text">província de:</span>
                    <input type="text" className="w-32 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.province} />
                </div>

                <div className="flex items-center gap-2 mb-1">
                    <span className="form-text">Doc. de Identif.:</span>
                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{studentIdentity?.documentType === 'BI' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">B.I.</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{studentIdentity?.birthCertificate ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">Bol. Nasc.</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{studentIdentity?.passport ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">Passaporte</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{studentIdentity?.dire ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">D.I.R.E.</span>
                        </div>
                    </div>
                    <span className="form-text ml-2">Nº</span>
                    <input type="text" className="flex-1 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.documentNumber} />
                </div>

                <div className="flex items-center gap-2">
                    <span className="form-text">Morada:</span>
                    <input type="text" className="w-64 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.address} />
                    <span className="form-text">Nº</span>
                    <input type="text" className="w-12 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.addressNumber} />
                    <span className="form-text">Andar</span>
                    <input type="text" className="w-12 border border-black px-2 py-0 form-text" />
                    <span className="form-text">Flat</span>
                    <input type="text" className="w-12 border border-black px-2 py-0 form-text" />
                    <input type="text" className="w-12 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.addressComplement} />
                    <input type="text" className="w-12 border border-black px-2 py-0 form-text" 
                        defaultValue={studentIdentity?.city} />
                </div>
            </div>

            {/* Filiação */}
            <div className="w-full">
                <h2 className="form-section-title">FILIAÇÃO</h2>
                <div className="flex gap-4">
                    {/* Tabela do Pai */}
                    <div className="flex-1 border border-black">
                        <div className="border-b border-black text-center px-2 py-0">
                            <span className="form-text">Pai</span>
                        </div>
                        <table className="w-full">
                            <tbody>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Nome:</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.father?.name} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Profissão</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.father?.profession} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Instituição<br />em que<br />trabalha</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.father?.workPlace} />
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan={4} className="border-b border-r border-black table-cell">
                                        <span className="form-text">Contactos<br />telefónicos</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Whatsapp:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.father?.whatsapp} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Telemóvel 2:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.father?.phone} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Residência:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.father?.residence} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Serviço:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.father?.service} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-r border-black table-cell">
                                        <span className="form-text">e-mails:</span>
                                    </td>
                                    <td className="table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.father?.email} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Tabela da Mãe */}
                    <div className="flex-1 border border-black">
                        <div className="border-b border-black text-center px-2 py-0">
                            <span className="form-text">Mãe</span>
                        </div>
                        <table className="w-full">
                            <tbody>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Nome:</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.mother?.name} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Profissão</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.mother?.profession} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Instituição<br />em que<br />trabalha</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.mother?.workPlace} />
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan={4} className="border-b border-r border-black table-cell">
                                        <span className="form-text">Contactos<br />telefónicos</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Whatsapp:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.mother?.whatsapp} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Telemóvel 2:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.mother?.phone} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Residência:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.mother?.residence} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Serviço:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={filiation?.mother?.service} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-r border-black table-cell">
                                        <span className="form-text">e-mails:</span>
                                    </td>
                                    <td className="table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={filiation?.mother?.email} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Encarregados de Educação */}
            <div className="w-full">
                <div className="flex items-center gap-4 mb-2">
                    <h2 className="form-section-title">ENCARREGADOS DE EDUCAÇÃOS SÃO OS PAIS?</h2>
                    <div className="flex gap-4">
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{educationGuardian === 'parents' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">Sim</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{educationGuardian === 'father' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">Só Pai</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{educationGuardian === 'mother' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">Só Mãe</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">{educationGuardian === 'other' ? 'X' : ''}</span>
                            </div>
                            <span className="form-text">OUTRO</span>
                        </div>
                    </div>
                </div>

                <div className="flex gap-4">
                    {/* Tabela do Encarregado */}
                    <div className="flex-1 border border-black">
                        <div className="border-b border-black text-center px-2 py-0">
                            <span className="form-text">Encarregado de Educação (qd diferente dos Pais)</span>
                        </div>
                        <table className="w-full">
                            <tbody>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Nome:</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={guardian?.name} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text">Profissão</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={guardian?.profession} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-r border-black table-cell">
                                        <span className="form-text leading-[1.1]">Instituição<br />em que<br />trabalha</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={guardian?.workPlace} />
                                    </td>
                                </tr>
                                <tr>
                                    <td rowSpan={4} className="border-b border-r border-black table-cell">
                                        <span className="form-text leading-[1.1]">Contactos<br />telefónicos</span>
                                    </td>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Whatsapp:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={guardian?.whatsapp} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Telemóvel 2:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={guardian?.phone} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Residência:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={guardian?.phone} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-b border-black table-cell">
                                        <div className="flex">
                                            <span className="form-text w-20">Serviço:</span>
                                            <input type="text" className="flex-1 form-text h-3.5" 
                                                defaultValue={guardian?.service} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border-r border-black table-cell">
                                        <span className="form-text">e-mails:</span>
                                    </td>
                                    <td className="table-cell">
                                        <input type="text" className="w-full form-text h-3.5" 
                                            defaultValue={guardian?.email} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Tabela de Contatos de Emergência */}
                    <div className="flex-1 border border-black">
                        <div className="border-b border-black text-center px-2 py-0">
                            <span className="form-text">Contactos de emergência</span>
                        </div>
                        <table className="w-full">
                            <tbody>
                                {emergencyContacts?.map((contact, index) => (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td className="border-b border-r border-black table-cell">
                                                <span className="form-text">Telefone:</span>
                                            </td>
                                            <td className="border-b border-black table-cell">
                                                <input type="text" className="w-full form-text h-3.5" 
                                                    defaultValue={contact.phone} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border-b border-r border-black table-cell">
                                                <span className="form-text">Pessoa a contactar:</span>
                                            </td>
                                            <td className="border-b border-black table-cell">
                                                <input type="text" className="w-full form-text h-3.5" 
                                                    defaultValue={contact.name} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="border-b border-r border-black table-cell">
                                                <span className="form-text">Grau de parentesco:</span>
                                            </td>
                                            <td className="border-b border-black table-cell">
                                                <input type="text" className="w-full form-text h-3.5" 
                                                    defaultValue={contact.relationship} />
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Outras Instituições */}
            <div className="w-full">
                <h2 className="form-section-title">OUTRAS INSTITUIÇÕES DE ENSINO QUE FREQUENTOU</h2>
                <table className="w-full border border-black">
                    <thead>
                        <tr>
                            <th className="border border-black table-header form-text text-center w-20 font-normal text-center">
                                Ano
                            </th>
                            <th className="border border-black table-header form-text text-center w-24 font-normal text-center">
                                Classe
                            </th>
                            <th className="border border-black table-header form-text flex-1 font-normal text-center">
                                Nome da Instituição
                            </th>
                            <th className="border border-black table-header form-text text-center w-32 font-normal text-center">
                                Local
                            </th>
                            <th className="border border-black table-header form-text text-center w-32 font-normal text-center">
                                Resultado Final
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.academicHistory?.map((history, i) => (
                            <tr key={i}>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" 
                                        defaultValue={history.year} />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" 
                                        defaultValue={history.grade} />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" 
                                        defaultValue={history.institution} />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" 
                                        defaultValue={history.location} />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" 
                                        defaultValue={history.result} />
                                </td>
                            </tr>
                        ))}
                        {/* Preencher linhas restantes se houver menos de 5 registros */}
                        {[...Array(5 - (data.academicHistory?.length || 0))].map((_, i) => (
                            <tr key={`empty-${i}`}>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" />
                                </td>
                                <td className="border-b border-r border-black table-cell">
                                    <input type="text" className="w-full form-text h-3.5" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Informações Adicionais */}
            <div className="w-full">
                <h2 className="form-section-title">INFORMAÇÕES ADICIONAIS</h2>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-2">
                        <span className="form-text w-48">Tem alguma doença crónica?</span>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.chronicDiseases?.length > 0 ? 'X' : ''}
                                </span>
                            </div>
                            <span className="form-text">Sim</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.chronicDiseases?.length > 0 ? '' : 'X'}
                                </span>
                            </div>
                            <span className="form-text">Não</span>
                        </div>
                        <span className="form-text ml-4">Qual?</span>
                        <input type="text" className="flex-1 border border-black px-2 py-0 form-text h-3.5" 
                            defaultValue={additionalInformation?.chronicDiseases} />
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="form-text w-48">Tem alguma alergia?</span>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.allergies?.length > 0 ? 'X' : ''}
                                </span>
                            </div>
                            <span className="form-text">Sim</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.allergies?.length > 0 ? '' : 'X'}
                                </span>
                            </div>
                            <span className="form-text">Não</span>
                        </div>
                        <span className="form-text ml-4">Qual?</span>
                        <input type="text" className="flex-1 border border-black px-2 py-0 form-text h-3.5" 
                            defaultValue={additionalInformation?.allergies} />
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="form-text w-48">Tem Seguro de Saúde?</span>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.insurance ? 'X' : ''}
                                </span>
                            </div>
                            <span className="form-text">Sim</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.insurance ? '' : 'X'}
                                </span>
                            </div>
                            <span className="form-text">Não</span>
                        </div>
                        <span className="form-text ml-4">Dados:</span>
                        <input type="text" className="flex-1 border border-black px-2 py-0 form-text h-3.5" 
                            defaultValue={additionalInformation?.healthInsuranceDetails} />
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="form-text w-48">Tem/teve irmão/a no Inst. Nilia?</span>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.hasSiblingInNilia ? 'X' : ''}
                                </span>
                            </div>
                            <span className="form-text">Sim</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.hasSiblingInNilia ? '' : 'X'}
                                </span>
                            </div>
                            <span className="form-text">Não</span>
                        </div>
                        <span className="form-text ml-4">Nome:</span>
                        <input type="text" className="flex-1 border border-black px-2 py-0 form-text h-3.5" 
                            defaultValue={additionalInformation?.siblingName} />
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="form-text w-48">O aluno é órfão?</span>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.isOrphan ? 'X' : ''}
                                </span>
                            </div>
                            <span className="form-text">Sim</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center">
                                <span className="form-text">
                                    {additionalInformation?.isOrphan ? '' : 'X'}
                                </span>
                            </div>
                            <span className="form-text">Não</span>
                        </div>
                        <span className="form-text ml-4">Se sim, de?</span>
                        <input type="text" className="w-32 border border-black px-2 py-0 form-text h-3.5" 
                            defaultValue={additionalInformation?.orphanDetails} />
                        <span className="form-text ml-4">Língua Materna:</span>
                        <input type="text" className="w-32 border border-black px-2 py-0 form-text h-3.5" 
                            defaultValue={additionalInformation?.motherTongue} />
                    </div>

                    <div className="mt-2">
                        <div className="flex gap-2">
                            <span className="form-text">Observação adicional:</span>
                        </div>
                        <div className="border border-black h-20 mt-1 p-2">
                            <span className="form-text">{additionalInformation?.otherInformation}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Rodapé com Data e Assinaturas */}
            <div className="w-full mt-12">
                <div className="text-center italic mb-12">
                    <p className="form-text">
                        Maputo, {new Date(data.createdAt).toLocaleDateString('pt-PT', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric'
                        })}
                    </p>
                </div>

                <div className="flex justify-between px-12">
                    <div className="text-center">
                        <div className="border-t border-black w-48">
                            <p className="form-text mt-1">O Encarregado de Educação</p>
                        </div>
                    </div>

                    <div className="text-center">
                        <div className="border-t border-black w-48">
                            <p className="form-text mt-1">A Directora Geral</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
